import React from 'react';

import { VimeoPlayer } from '@omnigenbiodata/ui';
import { useTranslation } from 'react-i18next';

interface ParticipantVideoProps {
  title?: string;
}

function ParticipantVideo({ title = '' }: ParticipantVideoProps) {
  const { t } = useTranslation('video');
  return (
    <>
      <VimeoPlayer videoUrl={t('url')} title={title} />
    </>
  );
}

export default ParticipantVideo;
